export default __webpack_public_path__ + "static/media/treePlus.d53ce0c3.svg";